import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { setNestedTableFilter } from "../../App/actions/dataActions"
import dict from "../../Data/dict.json"
import { FilterList } from "@material-ui/icons"

export default function FilterNestedTable(){
    const dispatch = useDispatch()

    // Redux State
    const layer = useSelector(state => state.layer, (left, right) => {
        return left.layer_id === right.layer_id &&
        left.field_parent?.uuid === right.field_parent?.uuid &&
        JSON.stringify(left.filtered_childs_shown) === JSON.stringify(right.filtered_childs_shown)
    })

    // Local State
    const [language, setLanguage] = useState("ina")
    const [isModal, setIsModal] = useState(false)
    const [fields, setFields] = useState([])
    const [cols, setCols] = useState([])
    const [selectedCol, setSelectedCol] = useState({key: "", name: "", type: ""})
    const [filteredValue, setFilteredValue] = useState([])
    const [filteredParams, setFilteredParams] = useState([])
    const [isExist, setIsExist] = useState(false)
    
    const handleSelectColumn = (e) => {
        const colKey = e.target.value
        const colName = cols?.find(col => col.key === colKey).name
        const colType = cols?.find(col => col.key === colKey).type
        setSelectedCol({
            key: colKey,
            name: colName,
            type: colType
        })
        const filteredFields = fields
            .map(field => field.properties[colKey])
            .filter(value => value !== undefined)
            setFilteredValue([...new Set(filteredFields)])
        }
        
        const handleSubmit = (e) => {
            e.preventDefault()
            const key = e.target["column"].value
            let value;
            const isColDate = selectedCol.type === "date"
            let startDate;
            let endDate;
            if(isColDate){
                startDate = e.target["start_date"].value
                endDate = e.target["end_date"].value
            } else {
            value = e.target["rowValue"].value
        }
        
        // Cari apakah sudah ada objek dengan key ini
        const existingIndex = filteredParams.findIndex(param => param.key === key)
        let newParams;
        if(existingIndex !== -1) {
            const updatedParams = [...filteredParams]
            const existing = updatedParams[existingIndex]
            
            if(!existing?.values?.includes(value)){
                updatedParams[existingIndex] = {
                    ...existing,
                    values: [...existing.values, value]
                }
            }
            newParams = updatedParams
        } else {
            newParams = [...filteredParams, {key, values: isColDate ? [startDate, endDate] : [value]}]
        }
        
        setFilteredParams(newParams)
        setSelectedCol({
            key: "",
            name: "",
            type: ""
        })
    }
    
    const handleUndoFilter = (key, value) => {
        const isColDate = cols.find(col => col.key === key).type === "date"

        setFilteredParams(prev => {
            const existingIndex = prev.findIndex(param => param.key === key);
            if(existingIndex === -1) return prev

            const existing = prev[existingIndex]

            if(isColDate){
                // Untuk date, hapus seluruh entri
                return [...prev.slice(0, existingIndex), ...prev.slice(existingIndex + 1)]
            } else {
                const newValues = existing.values.filter(v => v !== value);
                if(newValues.length === 0){
                    // Jika tidak ada nilai lagi, hapus entri
                    return [...prev.slice(0, existingIndex), ...prev.slice(existingIndex + 1)]
                } else {
                    return [
                        ...prev.slice(0, existingIndex),
                        {...existing, values: newValues},
                        ...prev.slice(existingIndex + 1)
                    ]
                }
            }
        })
    }
    
    const handleReset = () => {
        setSelectedCol({key: "", name: ""})
        setFilteredValue([])
        setFilteredParams([])
        setIsExist(false)
    }
    
    useEffect(() => {
        const lang = localStorage.getItem("language") || "ina"
        setLanguage(lang)
    },[])

    useEffect(() => {
        const {layer_id, geo_layer_list, field_parent, child_fields_shown} = layer
        const parent_uuid = field_parent?.uuid
        let geo_layer = geo_layer_list.find((e) => e?.geo_layer?._id === layer_id)
        geo_layer = geo_layer?.geo_layer ? geo_layer?.geo_layer : {}
        const selected_cols = geo_layer?.fields?.filter(item => item?.parent_uuid === parent_uuid)
        
        setCols(selected_cols)
        setFields(child_fields_shown)
    },[layer])

    useEffect(() => {
        const {child_fields_shown: fields} = layer;
        const parent_uuid = layer.field_parent?.uuid;
        let geo_layer = layer.geo_layer_list.find((e) => e?.geo_layer?._id === layer.layer_id);
        geo_layer = geo_layer?.geo_layer || {};
        const cols = geo_layer?.fields?.filter(item => item?.parent_uuid === parent_uuid) || []

        // Hitung filteredFields hanya saat dibutuhkan
        const filteredFields = fields.filter(field => {
            return filteredParams.every(param => {
                const fieldValue = field.properties[param.key]
                const col = cols.find(col => col.key === param.key);
                const isColDate = col?.type === "date"

                if(isColDate){
                    if(param.values.length < 2) return false
                    const fieldDate = new Date(fieldValue)
                    const [startDateStr, endDateStr] = param.values;
                    const startDate = new Date(startDateStr)
                    const endDate = new Date(endDateStr)
                    if(
                        isNaN(fieldDate.getTime()) ||
                        isNaN(startDate.getTime()) ||
                        isNaN(endDate.getTime())
                    ){
                        return false
                    }

                    return fieldDate >= startDate && fieldDate <= endDate
                }

                const fieldValueStr = fieldValue?.toString()
                const allowedValueStr = param.values.map(v => v.toString())
                return allowedValueStr.includes(fieldValueStr)
            })
        })
        // dispatch ke reducer
        const isFiltered = filteredParams.length > 0;
        dispatch(
            setNestedTableFilter({
                is_nested_table_filtered: isFiltered,
                filtered_childs_shown: isFiltered ? filteredFields : []
            })
        )
    },[filteredParams, layer, dispatch])

    return (
        <div
            style={{
                position: "relative"
            }}
        >
            {isModal ? (
                <div 
                    className="container background_white outline_black margin_bottom"
                    style={{
                        position: "absolute",
                        bottom: "100%",
                        left: 0,
                        width: "max-content",
                    }}
                >
                    <form onSubmit={handleSubmit}>
                        <div style={{marginBottom: "1rem"}}>
                            <p className="text_bold">{dict["Select a column to filter"][language]}</p>
                            <select 
                                className="input_new"
                                name="column"
                                onChange={handleSelectColumn}
                                value={selectedCol?.key}
                            >
                                <option hidden value="">{dict["Select Column"][language]}</option>
                                {cols?.map((col,index) => (
                                    <option key={col.key || index} value={col.key}>{col.name}</option>
                                ))}
                            </select>
                        </div>
                        
                        {selectedCol?.key ? (
                            <div>
                                <p className="text_bold">{dict["Choose"][language]} {selectedCol?.name}</p>
                                {selectedCol.type === "date" ? 
                                    (<div
                                        style={{display: "flex", flexDirection: "row", gap: 10, marginBottom: "5px"}}
                                    >
                                        <input type="date" className="input_new" name="start_date" />
                                        <input type="date" className="input_new" name="end_date" />
                                    </div>) 
                                    : 
                                    (<select
                                        className="input_new"
                                        name="rowValue"
                                        onChange={(e) => {
                                            const value = e.target.value
                                            filteredParams.forEach(param => {
                                                if(param.key === selectedCol.key && param?.values?.includes(value)){
                                                    setIsExist(true)
                                                } else {
                                                    setIsExist(false)
                                                }
                                            })
                                        }}
                                    >
                                        <option value="" hidden>{dict["Choose"][language]} {selectedCol?.name}</option>
                                        {filteredValue?.map((value,index) => (
                                            <option value={value} key={index}>{value}</option>
                                        ))}
                                    </select>)
                                }
                                <button
                                    disabled={isExist ? true : false}
                                    className={`button background_${isExist ? 'grey' : 'black'}`}
                                    type="submit"
                                >
                                    {dict["Filter"][language]}
                                </button>
                            </div>
                        ) : (<></>)}
                        
                    </form>

                    <p className="text_bold">{dict["Filtered parameters:"][language]}</p>
                    <button 
                        className="button background_black" 
                        style={{marginBottom: "1rem"}}
                        onClick={handleReset}
                    >
                        {dict["Reset (restore show all)"][language]}
                    </button>

                    {filteredParams.length ? (
                        <table className="table">
                            <tbody>
                                {filteredParams.map((param, index) => (
                                    <tr key={index}>
                                        <td>{cols.find(col => col.key === param.key).name}</td>
                                        <td>
                                            <div style={{display: "flex", flexDirection: "row", gap: 10}}>
                                                {cols.find(col => col.key === param.key).type === "date" ? 
                                                (
                                                    <div style={{display: "flex", flexDirection: "row", gap: 3, alignItems: "center"}}>
                                                        <p>{param?.values?.join(" s/d ")}</p>
                                                        <button 
                                                            className="button_small background_red"
                                                            onClick={() => handleUndoFilter(param.key, param.values)}
                                                        >x</button>
                                                    </div>
                                                ) 
                                                : 
                                                (<>
                                                    {param?.values?.map((value, index) => (
                                                    <div key={index} style={{display: "flex", flexDirection: "row", gap: 3, alignItems: "center"}}>
                                                        <p>{value}</p>
                                                        <button 
                                                            className="button_small background_red"
                                                            onClick={() => handleUndoFilter(param.key, value)}
                                                        >x</button>
                                                    </div>
                                                ))}
                                                </>)
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (<></>)}
                </div>
            ) : <></>}
            <button 
                // className="button background_black" 
                style={{
                    color: "rgb(1, 102, 203)", 
                    display: "flex",
                    alignItems: "center", 
                    gap: "5px", 
                    textTransform: "uppercase",
                }}
                onClick={() => {
                    if(isModal){
                        setIsModal(false)
                    } else {
                        setIsModal(true)
                    }
                }}
            >
                <FilterList style={{width: "20px"}}/>
                {dict["Filter"][language]}
            </button>
        </div>
    )
}